import { useContext, useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';
import ApiContext from 'src/provider/API/call-service';
import AppInfoContext from 'src/provider/state-manager/appInfoProvider';
import VisibilityContext from "src/provider/state-manager/visibilityProvider";
import { 
    AppSpan, AppText, Button, CustomContainer, FlexRow, 
    GridContainer, ScreenContainer, ScreenTitle 
} from "src/style"
import utility from "src/utils/utility"
import { IoIosArrowBack } from "react-icons/io";
import { Subsidiary } from 'src/model';
import {ReactComponent as SubsidiaryIcon} from 'src/assets/svg/subsidiary-lg-icon.svg';
import helpers from "src/utils/helpers";

const SubsidiaryDetails: React.FC<any> = () => {
    const navigate = useNavigate()
    const {API} = useContext(ApiContext)
    const {decisionBox} = useContext(VisibilityContext)
    const {info: {selectedSubsidiary}} = useContext(AppInfoContext)
    const [subsidiary, setSubsidiary] = useState<Subsidiary>(selectedSubsidiary)

    useEffect(() => {
        if (selectedSubsidiary?.id) setSubsidiary(selectedSubsidiary)
    }, [selectedSubsidiary])

    function handleRemoveSubsidiary () {
        decisionBox.show(
            'Are you sue you want to remove this subsidiary?',
            () => API.removeSubsidiary(subsidiary?.id),
            null,
            'negative',
            'Yes, Remove'
        )
    }

    return (
        <ScreenContainer padding='2.5'>
            <FlexRow 
                gap="2" width="auto" 
                sizeUnit="" bottomMargin='4'
            >
                <GridContainer 
                    width="4" height="4" 
                    borderColor="#5627FF"
                    radius="0.4"
                    onClick={() => navigate(-1)}
                >
                    <IoIosArrowBack color="#5627FF" fontSize='2.5rem' />
                </GridContainer>
                <CustomContainer 
                    height="4.9" 
                    width="0.1" 
                    borderColor="#E0E0E0" 
                />
                <CustomContainer width="auto" sizeUnit="">
                    <ScreenTitle 
                        color='#333333' 
                        textSize='2.4' 
                        fontWeight='700'
                    >
                        Subsidiary Details
                    </ScreenTitle>
                    <AppSpan color="#333333">Subsidiary &gt; Subsidiary Details</AppSpan>
                </CustomContainer>
            </FlexRow>

            <FlexRow 
                gap="2" justifyContent="space-between" 
                alignItems="flex-start"
                className='dashboard-charts-container'
            >
                <CustomContainer
                    width="67.5" sizeUnit="%"
                    className='dashboard-chart-wrapper' 
                >
                    <CustomContainer
                        minHeight="60" radius="0.4"
                        padding="2.5" bgColor="#ffffff"
                        shadow='0px 10px 50px 0px #0000000D'
                    >
                        <AppSpan textSize="1.6" color="#181D27" fontWeight="700">
                            Company Information
                        </AppSpan>
                        <FlexRow 
                            topMargin="2" wrap="wrap"
                            justifyContent="space-between" 
                            gap="5" alignItems="flex-start"
                        >
                            <CustomContainer width="20" sizeUnit="">
                                <AppSpan>Company Name</AppSpan>
                                <AppText color="#1D1D1D" fontWeight="500">{subsidiary?.name}</AppText>
                            </CustomContainer>
                            <CustomContainer width="20" sizeUnit="">
                                <AppSpan>Email Address</AppSpan>
                                <AppText color="#1D1D1D" fontWeight="500">{subsidiary?.email}</AppText>
                            </CustomContainer>
                            <CustomContainer width="20" sizeUnit="">
                                <AppSpan>Date Incorporated</AppSpan>
                                <AppText color="#1D1D1D" fontWeight="500">{subsidiary?.dateOfIncorporation ? helpers.splitDateTime(subsidiary?.dateOfIncorporation)?.date : ''}</AppText>
                            </CustomContainer>
                            <CustomContainer width="20" sizeUnit="">
                                <AppSpan>Phone Number</AppSpan>
                                <AppText color="#1D1D1D" fontWeight="500">{subsidiary?.phoneNumber}</AppText>
                            </CustomContainer>
                            <CustomContainer width="20" sizeUnit="">
                                <AppSpan>Phone Number 2</AppSpan>
                                <AppText color="#1D1D1D" fontWeight="500">--</AppText>
                            </CustomContainer>
                            <CustomContainer width="20" sizeUnit="">
                                <AppSpan>Official Website</AppSpan>
                                <AppText color="#1D1D1D" fontWeight="500">{subsidiary?.website}</AppText>
                            </CustomContainer>
                            <CustomContainer width="20" sizeUnit="">
                                <AppSpan>Official Address</AppSpan>
                                <AppText color="#1D1D1D" fontWeight="500">{subsidiary?.address}</AppText>
                            </CustomContainer>
                            <CustomContainer width="20" sizeUnit="">
                                <AppSpan>City</AppSpan>
                                <AppText color="#1D1D1D" fontWeight="500">{subsidiary?.city}</AppText>
                            </CustomContainer>
                            <CustomContainer width="20" sizeUnit="">
                                <AppSpan>State</AppSpan>
                                <AppText color="#1D1D1D" fontWeight="500">{subsidiary?.state}</AppText>
                            </CustomContainer>
                            <CustomContainer width="20" sizeUnit="">
                                <AppSpan>Country</AppSpan>
                                <AppText color="#1D1D1D" fontWeight="500">{subsidiary?.country || 'Nigeria'}</AppText>
                            </CustomContainer>
                        </FlexRow>
                    </CustomContainer>

                    <CustomContainer
                        minHeight="35.2" radius="0.4"
                        padding="2.5" bgColor="#ffffff"
                        shadow='0px 10px 50px 0px #0000000D'
                        topMargin='2'
                    >
                        <AppSpan textSize="1.6" color="#181D27" fontWeight="700">
                            Document
                        </AppSpan>
                        { subsidiary?.documentUrl &&
                            <FlexRow gap='3' wrap="wrap" alignItems='flex-start'>
                                <CustomContainer 
                                    width='35.7' height='23.4' 
                                    radius='0.4' borderColor='#000000'
                                >
                                    <img src={subsidiary.documentUrl} className='img-child'/>
                                </CustomContainer>
                                <CustomContainer width='auto' sizeUnit=''>
                                    <CustomContainer width="20" sizeUnit="" bottomMargin='2'>
                                        <AppSpan>Registration Number</AppSpan>
                                        <AppText color="#1D1D1D" fontWeight="500">{subsidiary.registrationNumber}</AppText>
                                    </CustomContainer>
                                    <CustomContainer width="20" sizeUnit="">
                                        <AppSpan>Verification Status</AppSpan>
                                        <AppText color="#1D1D1D" fontWeight="500">{subsidiary.verificationStatus}</AppText>
                                    </CustomContainer>
                                </CustomContainer>
                            </FlexRow>
                        }
                    </CustomContainer>

                    <Button 
                        width='18.5' 
                        hoverBgColor='#5627FF' 
                        hoverColor='#ffffff'
                        color="#5627FF"
                        bgColor="#ffffff"
                        borderColor='#5627FF'
                        topMargin="3.5"
                        onClick={handleRemoveSubsidiary}
                    >
                        Remove Subsidiary
                    </Button>
                </CustomContainer>

                <CustomContainer 
                    width="30" sizeUnit="%"
                    className='dashboard-chart-wrapper remove-1100'
                >
                    <SubsidiaryIcon className='icon-component' />
                </CustomContainer>
            </FlexRow>
        </ScreenContainer>
    )
}

export default utility.routeData('subsidiaries/subsidiary-details', 'Subsidiary Details', <SubsidiaryDetails/>)